import { Link } from 'gatsby';
import React from 'react';

export class ArchiveOverview extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    var right = JSON.parse(JSON.stringify(this.props.archives || []));
    right.sort((a,b) => (parseInt(a.year) - parseInt(b.year)));
    var left = right.splice(0, Math.ceil(right.length / 2));

    return (
      <section className="content-columns archive-overview">
        <div className="content-columns__container container">
          <div className="content-columns__left typo-body">
            { left.map(archive => <Link to={archive.slug}>{archive.year} - {archive.longTitle.replace('Archive', 'Europalia') }</Link>) }
          </div>
          <div className="content-columns__spacer" />
          <div className="content-columns__right typo-body">
            { right.map(archive => <Link to={archive.slug}>{archive.year} - {archive.longTitle.replace('Archive', 'Europalia')}</Link>) }
          </div>
        </div>
      </section>
    );
  }
}